// @ngInject
function BusinessAreasApiService(ResourcesService) {

  var endpoint = 'businessareas';

  return {
    getBusinessAreas: ResourcesService.apiFactory.get(endpoint),
    getBusinessArea: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createBusinessArea: ResourcesService.apiFactory.create(endpoint, 'BusinessArea'),
    updateBusinessArea: ResourcesService.apiFactory.update(endpoint, 'BusinessArea'),
    deleteBusinessArea: ResourcesService.apiFactory.delete(endpoint, 'BusinessArea')
  };

}

angular
  .module('businessareas.api', [])
  .factory('BusinessAreasApiService', BusinessAreasApiService);
